export default "__VITE_ASSET__adaa2c6e__"